import { Anlage } from "./anlage"

export class DateiAnlage extends Anlage {
    dateiname = ""
    groesse = 0
    inhalt = ""
    mimeType = ""

    get notEmpty(): boolean {
        return this.inhalt.trim().length > 0
    }

    toJSON() {
        return this.notEmpty
            ? {
                  "@type": "dateiAnlage",
                  name: this.name,
                  beschreibung: this.beschreibung,
                  dateiname: this.dateiname,
                  groesse: this.groesse,
                  mimeType: this.mimeType,
                  inhalt: this.inhalt,
              }
            : {}
    }
}
